import React from "react";
import { Helmet } from "react-helmet";
import PageTitle from "../../components/PageTitle";
import { Settings } from "../../configuration/settings";
import Item from "../../models/item";
import RecomendedItems from "../../components/RecomendedItems";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import { ModelDetails } from "../../configuration/model-description";

function OriginalityСheck(props: { items: Item[] }) {
    const topModels = Object.entries(ModelDetails)
        .sort(([, modelDetailsA], [, modelDetailsB]) => modelDetailsA.seoRank - modelDetailsB.seoRank)
        .map(([model, modelDetails]) => model)
        .slice(0, 4)
        .sort();
            
    return (
        <>
            <Helmet>
                <title>Як перевірити оригінальність джинсів Levi’s - {Settings.shopName}</title>
                <meta name="description" content={`Дізнайтесь, як перевірити оригінальність джинсів Levi’s: ярлики, фурнітура, патч, пошиття. Поради від інтернет-магазину ${Settings.shopName}.`} />
                <link rel="canonical" href={`${Settings.siteUrl}/yak-pereviryty-oryhinalnist-dzhynsiv-levis/`} />
            </Helmet>
            <Breadcrumbs items={[ { text: "Як перевірити оригінальність джинсів Levi’s"} ]} />
            <PageTitle title="Як перевірити оригінальність джинсів Levi’s: повний гід для покупця" />
            <div className="text-start">
                <p>
                    Джинси Levi’s - один із найвідоміших брендів у світі, тому їх часто підробляють.
                    Щоб не придбати фейк, важливо знати основні ознаки <strong>оригінальних чоловічих джинсів Levi’s</strong>. 
                    У цьому гіді ми розповімо, як перевірити справжність джинсів перед покупкою або після отримання замовлення.
                </p>

                <h2 className="fs-5">1. Фірмовий червоний ярлик Levi’s (Red Tab)</h2>
                <p>
                    Одна з головних візуальних ознак - <strong>червоний ярлик Levi’s</strong>,
                    який зазвичай розташований на задній кишені.
                </p>
                <ul>
                    <li>чіткий напис <strong>Levi’s</strong> без помилок</li>
                    <li>акуратно вшитий ярлик</li>
                    <li>якісна тканина без перекосів</li>
                </ul>
                <p>
                    У деяких моделях ярлик може бути чорним або без напису - це допустимо для окремих лінійок Levi’s.
                </p>

                <h2 className="fs-5">2. Патч Levi’s на поясі</h2>
                <p>
                    На задній частині поясу оригінальних джинсів Levi’s є <strong>фірмовий патч</strong> з 
                    логотипом та двома кіньми.
                </p>
                <ul>
                    <li>чіткий друк або тиснення</li>
                    <li>рівні краї без дефектів</li>
                    <li>відсутність різкого хімічного запаху</li>
                </ul>
                <p>
                    У підробках патч часто виглядає неякісно або має розмитий малюнок.
                </p>

                <h2 className="fs-5">3. Якість тканини та пошиття</h2>
                <p>
                    <strong>Оригінальні чоловічі джинси Levi’s</strong> відомі своєю міцністю та
                    довговічністю, тому зверніть увагу на деталі пошиття.
                </p>
                <ul>
                    <li>щільний денім, приємний на дотик</li>
                    <li>рівні шви без стирчачих ниток</li>
                    <li>посилені зони біля кишень</li>
                    <li>подвійні або потрійні шви</li>
                </ul>

                <h2 className="fs-5">4. Фірмова фурнітура Levi’s</h2>
                <p>
                    Оригінальні джинси Levi’s мають якісну брендовану фурнітуру:
                </p>

                <ul>
                    <li>ґудзик з гравіюванням <strong>Levi Strauss &amp; Co.</strong></li>
                    <li>блискавка від відомих виробників (YKK, Talon тощо)</li>
                    <li>металеві заклепки з чітким логотипом</li>
                </ul>

                <h2 className="fs-5">5. Внутрішні ярлики та модель</h2>
                <p>
                    Всередині джинсів Levi’s завжди є інформаційні ярлики:
                </p>
                <ul>
                    <li>розмір (W / L)</li>
                    <li>номер моделі (501, 511, 505 та інші)</li>
                    <li>склад тканини</li>
                    <li>країна виробництва</li>
                </ul>
                <p>
                    Levi’s виробляється в різних країнах, і це нормально. Країна пошиття не впливає на оригінальність виробу.
                </p>

                <h2 className="fs-5">6. Ціна та продавець</h2>
                <p>
                    Надто низька ціна - одна з головних ознак підробки.
                    Оригінальні джинси Levi’s мають стабільну ринкову вартість.
                </p>
                <p>
                    Купуйте джинси лише у спеціалізованих інтернет-магазинах,
                    які відкрито гарантують оригінальність товару.
                </p>

                <p>
                    Перед покупкою обов’язково перевірте <Link className="link-secondary" to="/tablytsia-rozmiriv-levis/">розмірну сітку джинсів Levi’s</Link> та 
                    дізнайтеся, <Link className="link-secondary" to="/yak-robyty-zamiry-dzhyns-levis/">як робити заміри джинсів Levi’s</Link>.  
                    Це допоможе підібрати ідеальні джинси та уникнути помилок.
                </p>
                <p>
                    Замовляйте оригінальні чоловічі джинси Levi’s прямо з <Link className="link-secondary" to="/">головної сторінки магазину</Link>.
                </p>

                <h2 className="fs-5">Чому варто купувати джинси Levi’s у {Settings.shopName}</h2>
                <p>
                    <strong>{Settings.shopName}</strong> - український інтернет-магазин, який з 2020 року
                    спеціалізується <strong>виключно на оригінальних чоловічих джинсах Levi’s</strong>.
                </p>
                <ul>
                    <li>100% оригінальні джинси Levi’s</li>
                    <li>перевірка кожної пари перед відправленням</li>
                    <li>допомога з підбором розміру</li>
                    <li>доставка по всій Україні</li>
                </ul>

                <h2 className="fs-5">Висновок</h2>
                <p>
                    Перевірити оригінальність джинсів Levi’s не складно, якщо знати основні ознаки.
                    Якість матеріалів, фурнітура та надійний продавець - ключові фактори вдалої покупки.
                </p>
                <p>
                    Якщо ви шукаєте <strong>оригінальні чоловічі джинси Levi’s в Україні</strong>,
                    інтернет-магазин {Settings.shopName} - це вибір, якому можна довіряти.
                </p>
            </div>
            <RecomendedItems items={props.items.filter(x => topModels.includes(String(x.model)))} title="Рекомендуємо джинси Levi’s"/>
        </>
    );
}

export default OriginalityСheck;